import React, { useState, useEffect } from 'react';
import { Row, Col, Typography, Pagination, Button } from 'antd';
import { 
    FireOutlined
} from '@ant-design/icons';
import auctionService from '../services/auctionService';
import BrowseLotCard from '../components/Auction/BrowseLotCard';
import BrowseLotCardSkeleton from '../components/Auction/BrowseLotCardSkeleton';
import '../components/Auction/FeaturedLots.css';
import '../components/Auction/AuctionList.css';
import './FeaturedPages.css';

const { Title, Text } = Typography;

const FeaturedLotsPage = () => {
    const [lots, setLots] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 12,
        total: 0
    });

    useEffect(() => {
        loadFeaturedLots();
    }, [pagination.current, pagination.pageSize]);

    const loadFeaturedLots = async () => {
        try {
            setLoading(true);
            const response = await auctionService.getFeaturedLots({ 
                page: pagination.current,
                per_page: pagination.pageSize
            });
            setLots(response.data || []);
            
            if (response.meta) {
                setPagination(prev => ({
                    ...prev,
                    current: response.meta.current_page || prev.current,
                    total: response.meta.total || 0,
                    pageSize: response.meta.per_page || prev.pageSize
                }));
            }
        } catch (error) {
            console.error('Error loading featured lots:', error);
        } finally {
            setLoading(false);
        }
    };

    const handlePaginationChange = (page, pageSize) => {
        setPagination(prev => ({
            ...prev,
            current: page,
            pageSize: pageSize
        }));
    };

    return (
        <div className="featured-page-container">
            {/* Professional Header */}
            <div className="featured-page-header">
                {/* Background decoration */}
                <div className="featured-page-header-decoration" />
                
                <div className="featured-page-header-content">
                    <div className="featured-page-header-title-wrapper">
                        <FireOutlined className="featured-page-header-icon" />
                        <Title level={1} className="featured-page-header-title">
                            All Featured Lots
                        </Title>
                    </div>
                    <Text className="featured-page-header-description">
                        Discover our handpicked selection of premium lots from top auctions
                    </Text>
                </div>
            </div>

            {loading ? (
                <Row gutter={[24, 24]}>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
                        <Col xs={24} sm={12} md={8} lg={8} key={item}>
                            <BrowseLotCardSkeleton />
                        </Col>
                    ))}
                </Row>
            ) : lots.length === 0 ? (
                <div className="empty-container">
                    <div className="empty-card">
                        <div style={{ 
                            fontSize: '64px', 
                            marginBottom: '24px',
                            opacity: 0.3
                        }}>
                            🏷️
                        </div>
                        <Text className="empty-title">
                            No featured lots found
                        </Text>
                        <Text className="empty-description">
                            No featured lots are currently available. Check back later for new featured lots.
                        </Text>
                    </div>
                </div>
            ) : (
                <>
                    <Row 
                        gutter={[24, 24]} 
                        className="featured-page-grid featured-lots-row"
                    >
                        {lots.map(lot => (
                            <Col 
                                xs={24} 
                                sm={12} 
                                md={8} 
                                lg={8} 
                                key={lot.id}
                                className="featured-page-col"
                            >
                                <div style={{ width: '100%', display: 'flex', height: '100%' }}>
                                    <BrowseLotCard lot={lot} />
                                </div>
                            </Col>
                        ))}
                    </Row>
                    
                    {pagination.total > 0 && (
                        <div className="featured-page-pagination">
                            <Pagination
                                current={pagination.current}
                                pageSize={pagination.pageSize}
                                total={pagination.total}
                                onChange={handlePaginationChange}
                                showSizeChanger={false}
                                responsive={true}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default FeaturedLotsPage;

